let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8Zr88")).then(() => parcelRequire('3STzC'));